import { Module } from '../Module';

interface IMatchingInputsValidatorScope extends ng.IScope {
  match: string;
}

Module.instance().directive('tbMatchingInputsValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        match: '='
      },
      link: (scope: IMatchingInputsValidatorScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        scope.$watch(() => {
          // compare passed in data against the current model value
          return attrs['matchData'] === ctrl.$modelValue;
        }, (currentValue) => {
          ctrl.$setValidity('match', currentValue);
        });
      }
    };
  }
);
